<div class="row">
    <div class="col-lg-12">
        <h1>Planned Orders</h1>

        <div class="epi-container">
            <h4>Filters</h4>
            <i class="fa" (click)="toggleFlag('filters')" [ngClass]="{'fa-plus': divFlags['filters'] == false, 'fa-minus': divFlags['filters'] == true}" aria-hidden="true"></i>

            <div *ngIf="divFlags['filters']">
                <div class="row m-0">
                    <div class="col-sm-2 border bg-light">
                        <h3>Primary Filters</h3>
                        <div class="row">
                            <div class="col-sm-6">
                                <label class="fw-bold">Begin Date</label>
                                <kendo-datepicker [(ngModel)]="beginDate" (valueChange)="onDateChange('beginDate')" [ngModelOptions]="{standalone: true}" required></kendo-datepicker>
                            </div>
                            <div class="col-sm-6">
                                <label class="fw-bold">End Date</label>
                                <kendo-datepicker [(ngModel)]="endDate" (valueChange)="onDateChange('endDate')" [ngModelOptions]="{standalone: true}" required></kendo-datepicker>
                            </div>
                        </div>
                        <div class="row" *ngIf="dateWarning!=''">
                            <div class="col-sm-12">
                                <label class="text-danger">{{dateWarning}}</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <label class="fw-bold">Origin</label>
                                <city-dropdown [parentForm]="orderPlannedForm" [ctrlName]="'originControl'" [placeholder]="'Select an Origin'" [isCityStateZip]="true"></city-dropdown>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <label class="fw-bold">Destination</label>
                                <city-dropdown [parentForm]="orderPlannedForm" [ctrlName]="'destinationControl'" [placeholder]="'Select a Destination'" [isCityStateZip]="true"></city-dropdown>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 text-end">
                                <button style="margin: 5px" class="btn btn-primary" [disabled]="isLoading||!isValidForm()" (click)="getLoads()">Search</button>
                                <button style="margin: 5px" class="btn btn-secondary" [disabled]="isLoading" (click)="resetFilters()">Reset Filters</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-10">
                        <h3>Secondary Filters</h3>
                        <div class="row">
                            <div class="col-sm-2">
                                <label class="fw-bold">Parent</label>
                                <div class="w-100 overflow-hidden">
                                    <customer-dropdown [parentForm]="orderPlannedForm" [ctrlName]="'parentCtrl'" [placeholder]="'Enter Code'"
                                                       [lookupType]="'parent'" (customerSelected)="onCustomerChange($event, 'parentCtrl')"></customer-dropdown>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <label class="fw-bold">Bill To</label>
                                <div class="w-100 overflow-hidden">
                                    <customer-dropdown [parentForm]="orderPlannedForm" [ctrlName]="'billToCtrl'" [placeholder]="'Enter Code'"
                                                       [lookupType]="''" (customerSelected)="onCustomerChange($event, 'billToCtrl')"></customer-dropdown>
                                </div>
                                <!--<input class="form-control" type="text" (keyup)="applyFilters()" [(ngModel)]="customerCode" />-->
                            </div>
                            <div class="col-sm-2">
                                <label class="fw-bold">Carrier</label>
                                <div class="w-100 overflow-hidden">
                                    <carrier-dropdown [parentForm]="orderPlannedForm" [ctrlName]="'carrierCtrl'" [placeholder]="'Enter Code'"
                                                      [carrierLookupType]="'Code'" (carrierSelected)="onCarrierChange($event)"></carrier-dropdown>
                                </div>
                                <!--<input class="form-control" type="text" (keyup)="applyFilters()" [(ngModel)]="carrierCode" />-->
                            </div>
                            <div class="col-sm-2">
                                <label class="fw-bold">Product</label>
                                <select name="productID" class="form-select" [(ngModel)]="productID" (change)="applyFilters()">
                                    <option value="0">- Select Product -</option>
                                    <option *ngFor="let item of productList" value="{{item.productId}}">{{item.productName}}</option>
                                </select>
                            </div>
                            <!--<div class="col-sm-2">
        <label class="fw-bold">Mode</label>
        <mat-select class="form-control" placeholder="Select Mode" [(ngModel)]="modeId">
            <mat-option [value]="0">--</mat-option>
            <mat-option *ngFor="let mode of modes" [value]="mode.modeId">
                {{mode.description}}
            </mat-option>
        </mat-select>
    </div>-->
                            <div class="col-sm-2">
                                <label class="fw-bold">Equipment Class</label>
                                <select name="equipmentClassID" class="form-select" [(ngModel)]="equipmentClassID" (change)="applyFilters()">
                                    <option value="0">- Select Class -</option>
                                    <option *ngFor="let item of equipmentClassList" value="{{item.equipmentClassID}}">{{item.abbreviation}} - {{item.className}}</option>
                                </select>
                            </div>
                            <div class="col-sm-2">
                                <label class="fw-bold">Trailer Type</label>
                                <select name="trailerTypeID" class="form-select" [(ngModel)]="trailerTypeID" (change)="applyFilters()">
                                    <option value="0">- Select Trailer -</option>
                                    <option *ngFor="let item of trailerTypeList" value="{{item.trailerTypeID}}">{{item.description}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-2">
                                <label class="fw-bold">Order Owner</label>
                                <select name="orderOwnerEmployeeID" class="form-select" [(ngModel)]="orderOwnerEmployeeID" (change)="applyFilters()">
                                    <option value="0">- Select Employee -</option>
                                    <option *ngFor="let item of orderOwners" value="{{item.employeeId}}">{{item.fullName}}</option>
                                </select>
                            </div>
                            <div class="col-sm-2">
                                <label class="fw-bold">Account Manager</label>
                                <select name="accountRepID" class="form-select" [(ngModel)]="accountRepID" (change)="applyFilters()">
                                    <option value="0">- Select Employee -</option>
                                    <option *ngFor="let item of accountReps" value="{{item.employeeId}}">{{item.fullName}}</option>
                                </select>
                            </div>
                            <div class="col-sm-2">
                                <label class="fw-bold">Ops Rep</label>
                                <select name="opsRepID" class="form-select" [(ngModel)]="opsRepID" (change)="applyFilters()">
                                    <option value="0">- Select Employee -</option>
                                    <option *ngFor="let item of opsReps" value="{{item.employeeId}}">{{item.fullName}}</option>
                                </select>
                            </div>
                            <div class="col-sm-2">
                                <label class="fw-bold">CSR</label>
                                <select name="salesRepID" class="form-select" [(ngModel)]="salesRepID" (change)="applyFilters()">
                                    <option value="0">- Select Employee -</option>
                                    <option *ngFor="let item of salesReps" value="{{item.employeeId}}">{{item.fullName}}</option>
                                </select>
                            </div>
                            <div class="col-sm-2">
                                <label class="fw-bold">Created By</label>
                                <select name="orderCreatedByEmployeeID" class="form-select" [(ngModel)]="orderCreatedByEmployeeID" (change)="applyFilters()">
                                    <option value="0">- Select Employee -</option>
                                    <option *ngFor="let item of orderCreatedByEmployees" value="{{item.employeeId}}">{{item.fullName}}</option>
                                </select>
                            </div>
                            <div class="col-sm-2">
                                <label class="fw-bold">Logistic Specialist</label>
                                <!--<input class="form-control" type="text" (keyup)="applyFilters()" [(ngModel)]="orderOwner" />-->
                                <select name="logisticSpecialistID" class="form-select" [(ngModel)]="logisticSpecialistID" (change)="applyFilters()">
                                    <option value="0">- Select Employee -</option>
                                    <option *ngFor="let item of logisticSpecialists" value="{{item.employeeID}}">{{item.employeeName}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-2">
                                <label class="fw-bold">Country-to-Country</label>
                                <br />
                                <mat-form-field>
                                    <mat-select name="c2cCtrl" (selectionChange)="c2cChange($event)" multiple>
                                        <mat-option *ngFor="let c2c of c2cList" [value]="c2c">{{c2c}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <!--<kendo-multiselect [data]="c2cList"
                           [autoClose]="true"
                           [valuePrimitive]="true"
                           style="overflow:hidden;width:200px;height:37px;"
                           [value]="selectedC2C"
                           (valueChange)="c2cChange($event)">
        </kendo-multiselect>-->
                                <!--[value]="c2cFilters(filter)"-->
                            </div>
                            <div class="col-sm-2">
                                <label class="fw-bold">Order #</label>
                                <input class="form-control" type="text" (keyup)="applyFilters()" [(ngModel)]="orderNumber" />
                            </div>
                            <div class="col-sm-2">
                                <label class="fw-bold">Tags</label>
                                <br />
                                <!--<button type="button" class="btn btn-sm btn-secondary float-right" (click)="isTagListFocus=!isTagListFocus">
            <i class="fas fa-xs" [ngClass]="isTagListFocus ? 'fa-minus' : 'fa-plus'" aria-hidden="true"></i>
        </button>-->
                                <div class="bg-white overflow-overlay border rounded"
                                     style="position:absolute;width:200px;z-index:2;"
                                     (click)="isTagListFocus=true"
                                     (mouseleave)="isTagListFocus=false"
                                     [ngStyle]="isTagListFocus ? {'overflow':'overlay','height':'250px','max-height':'250px'} : {'overflow':'hidden','height':'42px'}">
                                    <span class="text-secondary k-float-right m-2"><i class="fas fa-sort-down fa-lg"></i></span>
                                    <div *ngIf="tagTypeList.length>0">
                                        <div *ngFor="let tag of tagTypeList">
                                            <span class="btn m-1 text-nowrap" [ngClass]="checkSelectedTagType(tag) ? 'btn-' + tag.colorClassName : 'btn-light'" (click)="toggleTagType(tag)">
                                                <i class="fas fa-tag"></i>
                                                {{tag.tagTypePrefix != null && tag.tagTypePrefix != '' ? tag.tagTypePrefix + ' | ' : ''}}
                                                {{tag.tagTypeName}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <label class="fw-bold">Ref #</label>
                                <input class="form-control" type="text" (keyup)="applyFilters()" [(ngModel)]="refNum" />
                            </div>
                            <div class="col-sm-2">
                                <label class="fw-bold">Priority</label>
                                <select name="quoteOrderLinePriority" class="form-select" [(ngModel)]="quoteOrderLinePriority" (change)="applyFilters()">
                                    <option *ngFor="let item of quoteOrderLinePriorityList" value="{{item.abbrev}}">{{item.abbrev}}</option>
                                </select>
                            </div>
                            <div class="col-sm-2">
                                <label class="fw-bold">Round Trip?</label>
                                <input type="checkbox" style="margin:10px;transform: scale(1.5);"
                                       id="isRoundTrip" name="isRoundTrip"
                                       (change)="applyFilters()"
                                       [(ngModel)]="isRoundTrip"
                                       [ngModelOptions]="{standalone: true}"
                                       autocomplete="off" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-4">
                                <div class="row">
                                    <div class="col">
                                        <label class="fw-bold">Results View</label>
                                        <br />
                                        <input type="radio" id="resultsViewGrids" name="resultsView" [value]="'Grids'" style="margin:10px;transform: scale(2);"
                                               [checked]="resultsView=='Grids'" (click)="getResultsView('Grids')" />
                                        <label style="margin-right:1.0rem;" for="resultsViewGrids">Grids</label>
                                        <input type="radio" id="resultsViewCards" name="resultsView" [value]="'Cards'" style="margin:10px;transform: scale(2);"
                                               [checked]="resultsView=='Cards'" (click)="getResultsView('Cards')" />
                                        <label style="margin-right:1.0rem;" for="resultsViewCards">Cards</label>
                                        <input type="radio" id="resultsViewOrderList" name="resultsView" [value]="'Order List'" style="margin:10px;transform: scale(2);"
                                               [checked]="resultsView=='OrderList'" (click)="getResultsView('OrderList')" />
                                        <label style="margin-right:1.0rem;" for="resultsViewOrderList">Order List</label>
                                        <input type="radio" id="resultsViewRFQQuoteList" name="resultsView" [value]="'RFQ-Quote List'" style="margin:10px;transform: scale(2);"
                                               [checked]="resultsView=='RFQQuoteList'" (click)="getResultsView('RFQQuoteList')" />
                                        <label style="margin-right:1.0rem;" for="resultsViewRFQQuoteList">RFQ-Quote List</label>
                                    </div>
                                    <!--<div class="col-sm-6 text-end align-text-bottom">
                                        <br />
                                        <button style="margin: 5px" class="btn btn-primary" [disabled]="isLoading||!isValidForm()" (click)="getLoads()">Search</button>
                                        <button style="margin: 5px" class="btn btn-secondary" [disabled]="isLoading" (click)="resetFilters()">Reset Filters</button>
                                    </div>-->
                                </div>
                            </div>
                            <div class="col-sm-5" *ngIf="resultsView!='OrderList'">
                                <label class="fw-bold">Show/Hide Statuses</label>
                                <br />
                                <input type="checkbox" style="margin:10px;transform: scale(1.5);"
                                       id="isShowPlanned" name="isShowPlanned"
                                       (change)="setColSize()"
                                       [(ngModel)]="isShowPlanned"
                                       [ngModelOptions]="{standalone: true}"
                                       autocomplete="off" />
                                <label style="margin-right:1.0rem;" for="isShowPlanned">Planned</label>

                                <input type="checkbox" style="margin:10px;transform: scale(1.5);"
                                       id="isShowAvailable" name="isShowAvailable"
                                       (change)="setColSize()"
                                       [(ngModel)]="isShowAvailable"
                                       [ngModelOptions]="{standalone: true}"
                                       autocomplete="off" />
                                <label style="margin-right:1.0rem;" for="isShowAvailable">Available</label>

                                <input type="checkbox" style="margin:10px;transform: scale(1.5);"
                                       id="isShowTendered" name="isShowTendered"
                                       (change)="setColSize()"
                                       [(ngModel)]="isShowTendered"
                                       [ngModelOptions]="{standalone: true}"
                                       autocomplete="off" />
                                <label style="margin-right:1.0rem;" for="isShowTendered">Tendered</label>

                                <!--<input type="checkbox" style="margin:10px;transform: scale(1.5);"
                                       id="isShowAccepted" name="isShowAccepted"
                                       (change)="setColSize()"
                                       [(ngModel)]="isShowAccepted"
                                       [ngModelOptions]="{standalone: true}"
                                       autocomplete="off" />
                                <label style="margin-right:1.0rem;" for="isShowAccepted">Accepted</label>-->
                                <!--<input type="checkbox" style="margin:10px;transform: scale(1.5);"
                                       id="isShowDispatched" name="isShowDispatched"
                                       (change)="setColSize()"
                                       [(ngModel)]="isShowDispatched"
                                       [ngModelOptions]="{standalone: true}"
                                       autocomplete="off" />
                                <label style="margin-right:1.0rem;" for="isShowDispatched">Dispatched</label>-->

                                <input type="checkbox" style="margin:10px;transform: scale(1.5);"
                                       id="isShowStarted" name="isShowStarted"
                                       (change)="setColSize()"
                                       [(ngModel)]="isShowStarted"
                                       [ngModelOptions]="{standalone: true}"
                                       autocomplete="off" />
                                <label style="margin-right:1.0rem;" for="isShowStarted">Started</label>

                                <input type="checkbox" style="margin:10px;transform: scale(1.5);"
                                       id="isShowCompleted" name="isShowCompleted"
                                       (change)="setColSize()"
                                       [(ngModel)]="isShowCompleted"
                                       [ngModelOptions]="{standalone: true}"
                                       autocomplete="off" />
                                <label style="margin-right:1.0rem;" for="isShowCompleted">Completed</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row" *ngIf="resultsView=='Cards'&&!isLoading">
    <order-planned-card *ngIf="isShowPlanned"
                        [ngClass]="'col-lg-' + colSize"
                        [loads]="loadsPlanned"
                        [loadStatus]="'Planned'"
                        [cardSize]="cardSize"
                        (onClick)="openDialogClick($event)">
    </order-planned-card>
    <order-planned-card *ngIf="isShowAvailable"
                        [ngClass]="'col-lg-' + colSize"
                        [loads]="loadsAvailable"
                        [loadStatus]="'Available'"
                        [cardSize]="cardSize"
                        (onClick)="openDialogClick($event)">
    </order-planned-card>
    <order-planned-card *ngIf="isShowTendered"
                        [ngClass]="'col-lg-' + colSize"
                        [loads]="loadsTendered"
                        [loadStatus]="'Tendered'"
                        [cardSize]="cardSize"
                        (onClick)="openDialogClick($event)">
    </order-planned-card>
    <!--<order-planned-card *ngIf="isShowAccepted"
                        [ngClass]="'col-lg-' + colSize"
                        [loads]="loadsAccepted"
                        [loadStatus]="'Accepted'"
                        [cardSize]="cardSize"
                        (onClick)="openDialogClick($event)">
    </order-planned-card>-->
    <!--<order-planned-card *ngIf="isShowDispatched"
                        [ngClass]="'col-lg-' + colSize"
                        [loads]="loadsDispatched"
                        [loadStatus]="'Dispatched'"
                        [cardSize]="cardSize"
                        (onClick)="openDialogClick($event)">
    </order-planned-card>-->
    <order-planned-card *ngIf="isShowStarted"
                        [ngClass]="'col-lg-' + colSize"
                        [loads]="loadsStarted"
                        [loadStatus]="'Started'"
                        [cardSize]="cardSize"
                        (onClick)="openDialogClick($event)">
    </order-planned-card>
    <order-planned-card *ngIf="isShowCompleted"
                        [ngClass]="'col-lg-' + colSize"
                        [loads]="loadsCompleted"
                        [loadStatus]="'Completed'"
                        [cardSize]="cardSize"
                        (onClick)="openDialogClick($event)">
    </order-planned-card>
</div>

<div class="row" *ngIf="resultsView=='Grids'&&!isLoading">
    <order-planned-grid *ngIf="isShowPlanned"
                        [ngClass]="'col-lg-' + colSize"
                        [loads]="loadsPlanned"
                        [loadStatus]="'Planned'"
                        [gridSize]="gridSize"
                        (onClick)="openDialogClick($event)">
    </order-planned-grid>
    <order-planned-grid *ngIf="isShowAvailable"
                        [ngClass]="'col-lg-' + colSize"
                        [loads]="loadsAvailable"
                        [loadStatus]="'Available'"
                        [gridSize]="gridSize"
                        (onClick)="openDialogClick($event)">
    </order-planned-grid>
    <order-planned-grid *ngIf="isShowTendered"
                        [ngClass]="'col-lg-' + colSize"
                        [loads]="loadsTendered"
                        [loadStatus]="'Tendered'"
                        [gridSize]="gridSize"
                        (onClick)="openDialogClick($event)">
    </order-planned-grid>
    <!--<order-planned-grid *ngIf="isShowAccepted"
                        [ngClass]="'col-lg-' + colSize"
                        [loads]="loadsAccepted"
                        [loadStatus]="'Accepted'"
                        [gridSize]="gridSize"
                        (onClick)="openDialogClick($event)">
    </order-planned-grid>-->
    <!--<order-planned-grid *ngIf="isShowDispatched"
                        [ngClass]="'col-lg-' + colSize"
                        [loads]="loadsDispatched"
                        [loadStatus]="'Dispatched'"
                        [gridSize]="gridSize"
                        (onClick)="openDialogClick($event)">
    </order-planned-grid>-->
    <order-planned-grid *ngIf="isShowStarted"
                        [ngClass]="'col-lg-' + colSize"
                        [loads]="loadsStarted"
                        [loadStatus]="'Started'"
                        [gridSize]="gridSize"
                        (onClick)="openDialogClick($event)">
    </order-planned-grid>
    <order-planned-grid *ngIf="isShowCompleted"
                        [ngClass]="'col-lg-' + colSize"
                        [loads]="loadsCompleted"
                        [loadStatus]="'Completed'"
                        [gridSize]="gridSize"
                        (onClick)="openDialogClick($event)">
    </order-planned-grid>
</div>

<div class="row" *ngIf="resultsView=='OrderList'&&!isLoading">
    <order-planned-grid [ngClass]="'col-lg-12'"
                        [loads]="this.ordersGrid"
                        [loadStatus]="'Orders'"
                        [gridSize]="gridSize"
                        (onClick)="openDialogClick($event)">
    </order-planned-grid>
</div>

<div class="row" *ngIf="resultsView=='RFQQuoteList'&&!isLoading">
    <order-planned-grid [ngClass]="'col-lg-12'"
                        [rfqQuotes]="this.loadsRFQQuote"
                        [loadStatus]="'RFQ-Quote'"
                        [gridSize]="gridSize"
                        (onClick)="openDialogClick($event)">
    </order-planned-grid>
</div>

<div class="spinner_container dark-overlay" [ngClass]="{'dark-overlay':isLoading}" *ngIf="isLoading">
    <mat-spinner style="left: 50%; top: 50%" *ngIf="isLoading"></mat-spinner>
</div>
